var map = {
	"./1.avif": 9383,
	"./2.avif": 7966,
	"./3.avif": 6701,
	"./4.avif": 5668,
	"./4enhancednobg.avif": 2454,
	"./5.avif": 1379,
	"./6.avif": 9194,
	"./7.avif": 8185
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2822;